/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { Avatar, Box, IconButton, LinearProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DefaultProfilePic from "../../images/DefaultProfilePic.png";

interface IProps {
  previewImage?: any;
  onImageUpload?: (image: any) => void;
  profilePic?: string;
  isUploadDisabled?: boolean;
}

const UploadProfilePic = (props: IProps) => {
  const [imageSrc, setImageSrc] = useState<any>(DefaultProfilePic);
  const [previewImage, setPreviewImage] = useState<string>("");


  const fileInputRef = useRef<HTMLInputElement>(null);

  const selectImage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files as FileList;
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.svg)$/i;
    if (!allowedExtensions.exec(files?.[0].name)) {
      alert("Invalid Logo file format, please select a Image file");
      return false;
    } else {
      const selectedFiles = event.target.files as FileList;
      setPreviewImage(URL.createObjectURL(selectedFiles?.[0]));
      props.onImageUpload && props.onImageUpload(selectedFiles?.[0]);
    }
  };

  /**Set Profile Pic src if user has already profile pic */
  useEffect(() => {
    props.profilePic && setImageSrc(props.profilePic);
  }, []);

  useEffect(() => {
    props.profilePic && setImageSrc(props.profilePic);
  }, [props.profilePic]);

  /**If user uploads a image, update the same in state */
  useEffect(() => {
    previewImage && setImageSrc(previewImage);
  }, [previewImage]);

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };
  const commonStyles = {
    bgcolor: "background.paper",
    borderColor: "text.primary",
    m: 1,
    border: 1,
    width: "10rem",
    height: "10rem",
  };

  return (
    <Box
      className="AvatarBox"
      sx={{
        ...commonStyles,
      }}
    >
      <Avatar
        sx={{
          height: "22vh",
          width: "22vh",
          minHeight: "120px",
          minWidth: "120px",
          position: "flex",
        }}
        alt="Upload Logo"
        src={imageSrc}
      />

      {/* <ImageUpload /> */}
      {!props.isUploadDisabled && (
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            marginLeft: "-6vh",
            zIndex: 1,
          }}
        >
          <IconButton
            sx={{
              backgroundColor: "#101010",
              color: "white",
              height: "4vh",
              width: "4vh",
              borderBlockColor: "black",
              borderTop: "1vh",
              position: "relative",
              bottom: "0px",
            }}
            onClick={handleIconClick}
          >
            <EditIcon fontSize="small" sx={{ fontSize: ".8rem" }} />
          </IconButton>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={selectImage}
            style={{ display: "none" }}
          />
        </div>
      )}
    </Box>
  );
};

export default UploadProfilePic;
